import { Loader, Typography } from '@recruit-robin/robin-theme/web-components';
import { AnimatePresence, motion } from 'motion/react';

import { useStyles } from './LoadingPage.styles';

export const LoadingPage = ({ message }: { message: string }) => {
  const classes = useStyles();

  return (
    <AnimatePresence>
      <motion.div
        css={classes.loadingContainer}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.33, ease: [0.22, 0.9, 0.53, 1] }}>
        <Loader size={64} color={(c) => c.primary.fuchsia} variant="typing-1" />
        <Typography variant={(v) => v.heading[3]} color={(c) => c.neutral.variant[70]}>
          {message}
        </Typography>
      </motion.div>
    </AnimatePresence>
  );
};
